import React from 'react'
import { ImgWrapper, ModalImgDiv, ModalTextWrapper, ModalWrapper } from '../FinalModalStyledComponents'
import { TextRegular, CenterButtonContainer } from '../../../styles/GlobalStyledComponents'
import { colors } from '../../../styles/Colors'
import ModalImgDivSvg from '../../../assets/images/NoDebt/NoDebt.svg';
import Button from '../../../components/Button/Button';
import { ViewMode } from '../../../interfaces/Mode';
import IframeService from '../../../services/Iframe';
import TokenService from '../../../services/Token';
import { getRedirectionUrl } from '../../../utils/urlParams';
import { webviewMessage } from '../../../utils/webviewHelper';
import { UpToDateTitle } from './CardUpToDateStyledComponents';
import { useLocation } from 'react-router-dom';

const CardUpToDate = () => {

    const { red4, white } = colors;
    
    const viewMode = sessionStorage.getItem('pepper-view-mode');
    const verifyUser = useLocation().state.userName || sessionStorage.getItem('verifyCardName');
    const userName = verifyUser
      ? verifyUser.charAt(0).toUpperCase() + verifyUser.slice(1).toLowerCase()
      : '';

    const goToClientArea = () => {
    if (
      viewMode === ViewMode.APP ||
      viewMode === ViewMode.IFRAME ||
      viewMode === ViewMode.CLIENTES
    ) {
      if (viewMode === ViewMode.APP) {
        webviewMessage({ data: 'no debt' });
      } else if (viewMode === ViewMode.CLIENTES) {
        const winRef = window.opener;
        if (winRef) {
          const targetOrigin = document.referrer;
          winRef.postMessage('no debt', targetOrigin);
        }
      } else {
        IframeService.closeIframe('no debt');
      }
      TokenService.clearSession();
    } else {
      TokenService.clearSession();
      window.location.href = getRedirectionUrl(true);
    }
    };

  return (
    <ModalWrapper id="card-up-to-date-page">
        <ModalTextWrapper>
            <UpToDateTitle
                id="card-up-to-date-title"
                fontSize={24}
                align="center"
                lineHeight={32}
                fontWeight={700}
            >
                Hola <span>{userName}</span>
            </UpToDateTitle>
        </ModalTextWrapper>
        <ModalTextWrapper>
            <TextRegular
                id="no-debt"
                fontSize={18}
                fontWeight={400}
                lineHeight={24}
                color="gray6"
            >
                ¡Parece que no tienes nada pendiente! 😃
            </TextRegular>
        </ModalTextWrapper>
        <ModalTextWrapper>
            <TextRegular
                id="no-debt-text"
                color="gray6"
                fontSize={16}
                fontWeight={400}
                lineHeight={22}
            >
                Ingresa a tu área cliente para resolver cualquier duda con tu financiación.
            </TextRegular>
        </ModalTextWrapper>
        <ImgWrapper>
          <ModalImgDiv
            src={ModalImgDivSvg}
            alt="no debt"
            title="no debt image"
            width={''}
            height={''}
          />
        </ImgWrapper>
        <CenterButtonContainer>
            <Button
              color={white}
              border="2px solid"
              borderColor={red4}
              backgroundColor={red4}
              minWidth="280px"
              click={() => goToClientArea()}
              id="client-area-btn"
            >
              <TextRegular
                fontSize={14}
                color={white}
                lineHeight={20}
                fontWeight={600}
              >
                Área cliente
              </TextRegular>
            </Button>
        </CenterButtonContainer>
    </ModalWrapper>
  )
}

export default CardUpToDate;